import { render, staticRenderFns } from "./VCardTitle.vue?vue&type=template&id=72e162c6&scoped=true&lang=pug&functional=true"
import script from "./VCardTitle.vue?vue&type=script&lang=js"
export * from "./VCardTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "72e162c6",
  null
  
)

export default component.exports